'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var imageWidths = require('../../imageWidths-0e171afa.js');
var useImageTagFormatter = require('../../useImageTagFormatter-f52f46f2.js');
require('../../tslib.es6-130a177d.js');
require('react');
require('../../types-169d4b99.js');



exports.IMAGE_WIDTHS = imageWidths.IMAGE_WIDTHS;
exports.calculateImageHeight = useImageTagFormatter.calculateImageHeight;
exports.changePreformattedImageProperties = useImageTagFormatter.changePreformattedImageProperties;
exports.configureSize = useImageTagFormatter.configureSize;
exports.createImagePath = useImageTagFormatter.createImagePath;
exports.excludeTrimmingTags = useImageTagFormatter.excludeTrimmingTags;
exports.formatImage = useImageTagFormatter.formatImage;
exports.getImageSizeInfo = useImageTagFormatter.getImageSizeInfo;
exports.getShortPath = useImageTagFormatter.getShortPath;
exports.preFormatImage = useImageTagFormatter.preFormatImage;
exports.reformatImage = useImageTagFormatter.reformatImage;
exports.resizeImage = useImageTagFormatter.resizeImage;
exports.useImageTagFormatter = useImageTagFormatter.useImageTagFormatter;
//# sourceMappingURL=index.js.map
